var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[_c('sidebar-menu',{attrs:{"menu":_vm.menu,"collapsed":_vm.collapsed,"relative":true,"width":"100%","widthCollapsed":"5em","hideToggle":true,"disableHover":true},on:{"item-click":_vm.onItemClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }